import store from '@/store/store';
import axios from 'axios';
import { errorHandlerCredenciamento } from '@/shared/auth/errorHandlerCredenciamento.js';
import { falhaNaoMapeadaHandler } from '@/shared/auth/falhaNaoMapeadaHandler';

export const axiosJwtCredenciamento = axios.create({
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosJwtCredenciamento.interceptors.request.use(
    (config) => {
        const token = store.getters.getToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosJwtCredenciamento.interceptors.response.use(
    (response) => {
        return { success: true, data: response.data };
    },
    (error) => {
        return { success: false, errors: errorHandlerCredenciamento(error), falhaNaoMapeada: falhaNaoMapeadaHandler(error) };
    }
);
